import React, { FC, ReactNode } from 'react'
import '../icon.scss'

export const LandDevelopmentPotentialNeutralIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/neutral/f218c63fe174b41c61f2b53f36c68841_IS24_Land_Potential_NeutralIcon.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
